var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import { XForm } from "@bluelibs/x-ui-admin";
import { Service, Inject } from "@bluelibs/core";
import { SmileOutlined } from "@ant-design/icons";
import * as Ant from "antd";
import { CompaniesCollection, ExternalsCollection, BankAccountsCollection, TransactionsCollection, } from "@bundles/UIAppBundle/collections";
import { ApolloError } from "@apollo/client";
let TransactionEditForm = class TransactionEditForm extends XForm {
    build() {
        const { UIComponents } = this;
        const { t } = this.i18n;
        this.add([
            {
                id: "type",
                label: t("management.transactions.fields.type"),
                name: ["type"],
                required: true,
                component: (props) => {
                    const items = {
                        income: t("management.transactions.create.transaction_type.income"),
                        expense: t("management.transactions.create.transaction_type.expense"),
                        internal: t("management.transactions.create.transaction_type.internal"),
                    };
                    return items[props.value];
                },
            },
            {
                id: "transactionDate",
                label: t("management.transactions.fields.transactionDate"),
                name: ["transactionDate"],
                required: true,
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.DatePicker, { required: true }, void 0) }), void 0)),
            },
            {
                id: "transactionIdentifier",
                label: t("management.transactions.fields.transactionIdentifier"),
                name: ["transactionIdentifier"],
                component: Ant.Input,
            },
            {
                id: "dueDate",
                label: t("management.transactions.fields.dueDate"),
                name: ["dueDate"],
                tooltip: t("management.transactions.fields.dueDate_description"),
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.DatePicker, { required: false }, void 0) }), void 0)),
            },
            {
                id: "amount",
                label: t("management.transactions.fields.amount"),
                name: ["amount"],
                required: true,
                component: Ant.InputNumber,
            },
            {
                id: "completeDate",
                label: t("management.transactions.fields.completeDate"),
                name: ["completeDate"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.DatePicker, { required: false }, void 0) }), void 0)),
            },
            {
                id: "notes",
                label: t("management.transactions.fields.notes"),
                name: ["notes"],
                component: Ant.Input,
            },
            {
                id: "companyId",
                label: t("management.transactions.fields.company"),
                name: ["companyId"],
                required: true,
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: CompaniesCollection, field: "name", required: true }, void 0) }), void 0)),
            },
            {
                id: "externalId",
                label: t("management.transactions.fields.external"),
                name: ["externalId"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: ExternalsCollection, field: "name", required: false }, void 0) }), void 0)),
            },
            {
                id: "sourceBankAccountId",
                label: t("management.transactions.fields.sourceBankAccount"),
                name: ["sourceBankAccountId"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: BankAccountsCollection, field: "accountNumber", required: false }, void 0) }), void 0)),
            },
            {
                id: "destinationBankAccountId",
                label: t("management.transactions.fields.destinationBankAccount"),
                name: ["destinationBankAccountId"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: BankAccountsCollection, field: "accountNumber", required: false }, void 0) }), void 0)),
            },
            {
                id: "transactionFilesIds",
                label: t("management.transactions.fields.transactionFiles"),
                name: ["transactionFilesIds"],
                component: UIComponents.AdminFilesUpload,
                componentProps: { field: "_id" },
            },
        ]);
    }
    static getRequestBody() {
        return {
            _id: 1,
            type: 1,
            transactionDate: 1,
            transactionIdentifier: 1,
            dueDate: 1,
            amount: 1,
            isCompleted: 1,
            completeDate: 1,
            notes: 1,
            approval: { status: 1 },
            company: {
                _id: 1,
                name: 1,
            },
            companyId: 1,
            external: {
                _id: 1,
                name: 1,
            },
            externalId: 1,
            sourceBankAccount: {
                _id: 1,
                accountNumber: 1,
            },
            sourceBankAccountId: 1,
            destinationBankAccount: {
                _id: 1,
                accountNumber: 1,
            },
            destinationBankAccountId: 1,
            transactionFiles: {
                _id: 1,
                downloadUrl: 1,
                name: 1,
            },
            transactionFilesIds: 1,
        };
    }
    onSubmit(_id, values) {
        const { t } = this.i18n;
        return this.collection
            .updateOne(_id, { $set: values })
            .then(({ _id }) => {
            Ant.notification.success({
                message: t("generics.success"),
                description: t("management.transactions.edit_confirmation"),
                icon: _jsx(SmileOutlined, {}, void 0),
            });
        })
            .catch((err) => {
            if (err instanceof ApolloError) {
                const errMessage = err.message.toLowerCase().split(" ").join("_");
                const i18nMessage = t(`apiErrors.${errMessage}`);
                Ant.notification.warn({
                    message: t("generics.error"),
                    description: i18nMessage,
                });
            }
            else {
                Ant.notification.warn({
                    message: t("generics.error"),
                    description: t("generics.error_message"),
                });
            }
        });
    }
};
__decorate([
    Inject(() => TransactionsCollection),
    __metadata("design:type", typeof (_a = typeof TransactionsCollection !== "undefined" && TransactionsCollection) === "function" ? _a : Object)
], TransactionEditForm.prototype, "collection", void 0);
TransactionEditForm = __decorate([
    Service({ transient: true })
], TransactionEditForm);
export { TransactionEditForm };
